var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorIllustration = function SvgErrorIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 149 69",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#EF4123"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.46 42.013c-.078-.235-5.727-20.407 17.544-27.658L63.5 54.17l.234 1.301-1.04.195a58.568 58.568 0 0 1-10.361 1.146c-7.341 0-14.539-2.824-18.872-14.798z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.51 55.6c-4.114 0-9.11-9.345-11.897-18.741a54.846 54.846 0 0 1-2.498-14.798c0-4.478.99-7.146 2.903-7.706 1.913-.559 4.203 1.12 6.637 4.868a54.82 54.82 0 0 1 6 13.757c2.966 9.97 3.839 21.254-.404 22.516-.24.07-.49.106-.741.104z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EF4123",
    fillRule: "nonzero",
    d: "M114.576 39.62l31.854 11.435c1.371.492 2.288 2.063 2.048 3.501l-.01.062c-.24 1.442-1.548 2.229-2.937 1.754l-30.955-10.59V39.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M1.039 55.437c-.24-1.443.66-3.043 2.025-3.582L34.06 39.62l.88 5.282L3.945 57.138c-1.358.537-2.655-.202-2.895-1.64l-.01-.061z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EF4123",
    d: "M34.448 44.623l-.733-4.393-30.49 12.035c-1.17.462-1.958 1.86-1.751 3.1l.01.061c.193 1.162 1.202 1.734 2.3 1.302l30.665-12.105h-.001z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C0C7CF",
    stroke: "#C0C7CF",
    d: "M33.46 42.013c-.078-.235-5.727-20.407 17.544-27.658L63.5 54.17l.234 1.301-1.040.195a58.568 58.568 0 0 1-10.361 1.146c-7.341 0-14.539-2.824-18.872-14.798z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#C0C7CF",
    d: "M62.51 55.6c-4.114 0-9.11-9.345-11.897-18.741a54.846 54.846 0 0 1-2.498-14.798c0-4.478.99-7.146 2.903-7.706 1.913-.559 4.203 1.12 6.637 4.868a54.82 54.82 0 0 1 6 13.757c2.966 9.97 3.839 21.254-.404 22.516-.24.07-.49.106-.741.104z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0C7CF",
    d: "M88.436 55.51l-1.042-.196.235-1.301 12.494-39.853c23.272 7.25 17.623 27.41 17.558 27.62-4.282 12.233-11.493 15.03-18.833 15.03a58.4 58.4 0 0 1-10.412-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#C0C7CF",
    d: "M87.915 55.535c-4.23-1.301-3.37-12.546-.403-22.516 2.967-9.97 8.381-19.886 12.637-18.637 4.256 1.25 3.371 12.546.404 22.516-2.785 9.384-7.77 18.742-11.883 18.742a2.607 2.607 0 0 1-.755-.105z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF4123",
    d: "M92.21 42.676a2.448 2.448 0 0 1-.69-.103l-.871-.261a2.448 2.448 0 0 1 1.405-4.685l.871.26a2.448 2.448 0 0 1-.702 4.79h-.013zM98.836 27.956a2.121 2.121 0 0 1-2.639 1.428l-.86-.256a2.121 2.121 0 1 1 1.21-4.067l.86.256a2.121 2.121 0 0 1 1.429 2.639z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0C7CF",
    d: "M114.576 39.62l31.854 11.435c1.371.492 2.288 2.063 2.048 3.501l-.01.062c-.24 1.442-1.548 2.229-2.937 1.754l-30.955-10.59V39.62z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#C0C7CF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.039 55.437c-.24-1.443.66-3.043 2.025-3.582L34.06 39.62l.88 5.282L3.945 57.138c-1.358.537-2.655-.202-2.895-1.64l-.01-.061z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#EF4123",
    d: "M69.883 5.064l-3.808 1.993L63.89 0l-.38 12.12 3.808-2.005 3.35 9.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF4123",
    fillRule: "nonzero",
    d: "M69.322 37.537a2.117 2.117 0 0 1 2.64 1.428 2.117 2.117 0 0 1-1.43 2.64l-9.754 2.901a.819.819 0 0 1-1.022-.56l-.738-2.48a.832.832 0 0 1 .55-1.027l9.754-2.902zM64.71 22.053a2.117 2.117 0 0 1 2.639 1.428 2.117 2.117 0 0 1-1.43 2.639l-9.753 2.902a.819.819 0 0 1-1.023-.56l-.738-2.479a.832.832 0 0 1 .55-1.028l9.755-2.902z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.883 5.064l-3.808 1.993L63.89 0l-.38 12.12 3.808-2.005 3.35 9.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0C7CF",
    fillRule: "nonzero",
    d: "M79.702 42.072a2.109 2.109 0 0 1-1.822-3.163 2.109 2.109 0 0 1 2.877-.769 2.109 2.109 0 0 1-.508 3.905c-.18.032-.364.041-.546.027zm-1.301-2.838a1.458 1.458 0 0 0 .533 1.926 1.42 1.42 0 0 0 1.107.144 1.458 1.458 0 0 0 .351-2.604 1.458 1.458 0 0 0-1.991.534zm-.46-26.212a2.109 2.109 0 1 1 .008-4.218 2.109 2.109 0 0 1-.008 4.218zm-1.301-2.838a1.458 1.458 0 1 0 2.603.352 1.458 1.458 0 0 0-2.669-.352h.066zM62.974 68.498a2.109 2.109 0 0 1-1.823-3.164 2.109 2.109 0 1 1 2.37 3.085c-.178.05-.361.076-.546.078h-.001zm-1.301-2.838a1.458 1.458 0 0 0 2.525 1.457 1.458 1.458 0 1 0-2.512-1.457h-.013zm17.8-38.642l-3.134-.898 2.504-4.99-6.528 6.404 3.144.898-1.91 4.903 5.924-6.317z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE2A24",
    d: "M76.462 49.81l-2.676 1.92-2.351-5.067.96 9.116 2.687-1.92 3.51 7.044z"
  }))));
};
export default SvgErrorIllustration;